import styles from './ProgressMeter.module.css';

export interface IProgressMeterProps {
  /** Percent complete, 0–100. */
  value: number;
  /** Sizes the track through `--meter-width` (default: the full width). */
  className?: string;
}

/**
 * A slim progress track in the drawer slider's colours (`ui/Slider`: grey
 * track, info-blue fill). Decorative: it sits beside the number written as
 * text, so it is hidden from assistive tech rather than announced twice.
 */
export function ProgressMeter({ value, className = '' }: IProgressMeterProps) {
  const percent = Math.min(100, Math.max(0, value));
  return (
    <span className={`${styles.track} ${className}`} aria-hidden data-value={percent}>
      <span className={styles.fill} style={{ width: `${percent}%` }} />
    </span>
  );
}
